import React from "react";
import API_ROUTES from "../../constants/apis";
import axios from "axios";
import { logoutUser } from "../../services/utils";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await axios.post(API_ROUTES.LOGOUT);
      console.log("User logged out");
      logoutUser();
      console.log("Navigating to root path");
      navigate("/");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  }
  return <span onClick={handleLogout}>Logout</span>;
}

export default Logout;
